import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LandingPage.css";

const Contact = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@ritesoccer.com?subject=Contact from Rite Soccer Website&body=Hello Rite Soccer team,%0D%0A%0D%0AI hope this email finds you well. I'm reaching out regarding...";
  };

  return (
    <>
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="landing-page">
        {/* Contact Header Section */}
        <section className="hero1" style={{ minHeight: "100vh", display: "flex", alignItems: "center", paddingTop: "80px", backgroundColor:'white !important' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <h1 className="hero-title1" style={{ fontSize: "48px", marginBottom: "20px" }}>Contact Us</h1>
                <p className="hero-subtitle1" style={{ fontSize: "18px", marginBottom: "60px", maxWidth: "600px", margin: "0 auto 60px auto" }}>
                  Have questions about Rite Soccer? We'd love to hear from you. Click the
                  button below to send us an email and we'll respond as soon as possible.
                </p>
              </div>
            </div>

            {/* Main Contact Card */}
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 col-12">
                <div 
                  style={{
                    background: "black",
                    borderRadius: "20px",
                    padding: "50px 40px",
                    textAlign: "center",
                    border: "1px solid rgba(255, 255, 255, 0.1)"
                  }}
                >
                  {/* Logo */}
                  <div style={{ marginBottom: "30px" }}>
                    <img 
                      src="./assets/logo1.png" 
                      alt="Rite Soccer Logo" 
                      style={{ height: "60px",  }}
                    />
                  </div>

                  <h2 style={{ color: "white", fontSize: "32px", fontWeight: "600", marginBottom: "20px" }}>
                    Get in touch with our team
                  </h2>

                  <p style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.6", marginBottom: "40px" }}>
                    Click the button below to open your email client and send us a message
                    directly. We'll get back to you as soon as possible.
                  </p>

                  {/* Email Button */}
                  <button 
                    onClick={handleEmailClick}
                    style={{
                      backgroundColor: "#005214",
                      color: "white",
                      border: "none",
                      borderRadius: "50px",
                      padding: "15px 30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      cursor: "pointer",
                      marginBottom: "30px",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "10px",
                      transition: "all 0.3s ease"
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#004012";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#005214";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    ✓ Send Email to Support
                  </button>

                  <p style={{ color: "#888", fontSize: "14px" }}>
                    Or email us directly at: <a href="mailto:info@ritesoccer.com" style={{ color: "white", textDecoration: "none" }}>info@ritesoccer.com</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Support Info Cards */}
            <div className="row justify-content-center" style={{ marginTop: "50px" }}>
              <div className="col-lg-5 col-md-6 col-12 mb-4">
                <div 
                  style={{
                    background: "black",
                    borderRadius: "15px",
                    padding: "30px",
                    textAlign: "left",
                    border: "1px solid rgba(255, 255, 255, 0.1)"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <div 
                      style={{
                        backgroundColor: "#005214",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px"
                      }}
                    >
                      <span style={{ color: "white", fontSize: "18px" }}>✓</span>
                    </div>
                    <h3 style={{ color: "white", fontSize: "20px", fontWeight: "600", margin: 0 }}>Support Hours</h3>
                  </div>
                  <p style={{ color: "#ccc", fontSize: "16px", margin: 0, paddingLeft: "55px" }}>
                    Monday - Friday: 9:00 AM - 6:00 PM EST
                  </p>
                </div>
              </div>

              <div className="col-lg-5 col-md-6 col-12 mb-4">
                <div 
                  style={{
                    background: "black",
                    borderRadius: "15px",
                    padding: "30px",
                    textAlign: "left",
                    border: "1px solid rgba(255, 255, 255, 0.1)"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <div 
                      style={{
                        backgroundColor: "#005214",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px"
                      }}
                    >
                      <span style={{ color: "white", fontSize: "18px" }}>✓</span>
                    </div>
                    <h3 style={{ color: "white", fontSize: "20px", fontWeight: "600", margin: 0 }}>Response Time</h3>
                  </div>
                  <p style={{ color: "#ccc", fontSize: "16px", margin: 0, paddingLeft: "55px" }}>
                    We typically respond within 24 hours
                  </p>
                </div>
              </div>
            </div>

            {/* FAQ Section */}
            <div className="row justify-content-center" style={{ marginTop: "50px" }}>
              <div className="col-lg-10 col-12">
                <div 
                  style={{
                    background: "black",
                    borderRadius: "15px",
                    padding: "40px",
                    textAlign: "center",
                    border: "1px solid rgba(255, 255, 255, 0.1)"
                  }}
                >
                  <h3 style={{ color: "white", fontSize: "24px", fontWeight: "600", marginBottom: "15px" }}>
                    Frequently Asked Questions
                  </h3>
                  <p style={{ color: "#ccc", fontSize: "16px", marginBottom: "25px" }}>
                    Before reaching out, check our <Link to="/#faq-latest" style={{ color: "#ffffff", textDecoration: "none" }}>FAQ section</Link> on the homepage for quick answers to common questions about subscriptions, features, and technical support.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Footer */}
        <footer className="footer" id="footer-contact">
          <div className="container">
            <div className="text-center">
              <img
                src="./assets/footer-logo.png"
                alt="Rite Soccer Logo"
                className="mb-3 footer-logo"
              />

              <h2>Let's connect</h2>

              <p>
                Say hello by email for inquiries, support, partnerships or
                promotion <br></br>
                (
                <a href="mailto:info@ritesoccer.com">info@ritesoccer.com</a>)
              </p>
              <div className="col-12 text-center mb-4">
                <p className="mb-0 address">
                  <img src="./assets/map.png" style={{ width: '14px' }} /> 35 Payne Street, Quincy MA.
                </p>
              </div>

              {/* Social Icons Row */}
              <div className="row justify-content-center g-3 social-icons">
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/x-icon.png" alt="X" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/instagram-icon.png" alt="Instagram" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/tiktok-icon.png" alt="TikTok" />
                  </a>
                </div>
              </div>
            </div>

            <div className="row copy-right">
              <div className="col-6 text-start">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-6 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "flex-end",
                }}
              > 
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

            <div className="copy-right-mob">
              <div className="col-mob text-center">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-12 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

          </div>
        </footer>
      </div>

      <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default Contact;